module.exports = __webpack_public_path__ + "public/fonts/Siemens_Global_CC_Roman.2dc4dd77.woff";